import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/akari.json";
import fr from "@/locales/fr/puzzle-types/akari.json";

export const AKARI_NS = "puzzle-types/akari";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerAkariTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", AKARI_NS))
    i18n.addResourceBundle("en", AKARI_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", AKARI_NS))
    i18n.addResourceBundle("fr", AKARI_NS, fr, true, true);
}
